export default {
    email: {
        required: true,
        email: true
    },
    phone: {
        required: true
    },
}